import type { IThemePageMessageToastKey } from '../types';
import type { MessageToast } from '~/modules/campaign';

export const THEME_PAGE_MSG: Record<IThemePageMessageToastKey, MessageToast> = {
  DELETE: {
    SUCCESS: 'Template deleted',
    FAILED: 'Delete template failed',
  },
  DELETE_BULK: {
    SUCCESS: 'Templates deleted',
    FAILED: 'Delete templates failed',
  },
  DELETE_VARIANTS: {
    SUCCESS: 'Variants deleted',
    FAILED: 'Delete variants failed',
  },
  DUPLICATE: {
    SUCCESS: 'Template duplicated',
    FAILED: 'Duplicate template failed',
  },
  PUBLISH: {
    SUCCESS: 'Template published',
    FAILED: 'Publish template failed',
  },
};
